require('../../node_modules/jquery-mask-plugin/dist/jquery.mask');

export function buildMeses(selected) {

    let mesesOptions = [];
    for (let i = 1; i <= 12; i++) {
        mesesOptions.push(`<option value="${i}" ${i === selected ? 'selected' : ''}>${i < 10 ? '0' + i : i}</option>`);
    }

    return mesesOptions.join('');
}

export function getDate(date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    return `${date.getFullYear()}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
}

export function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export function formatReal(decimal, moeda = false) {
    let value = parseFloat(decimal);
    if (moeda) {
        return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    }
    return value.toLocaleString('pt-br', { minimumFractionDigits: 2 });
}

export function formatDate(datetime, dateOnly = false) {
    let string = datetime.split(' ');
    const date = string[0].split('-').reverse().join('/');
    const time = string[1];

    if (!dateOnly) {
        return date;
    }

    return `${date} ${time}`;
}

export function showModal(title, body, footer = '', id = '#modal') {

    const $modal = $(id);

    if (id !== '#modalDropzone') {
        $modal.find('.modal-title').html('');
        $modal.find('.modal-body').html('');
        $modal.find('.modal-footer').html('');
    }

    if (title) {
        $modal.find('.modal-title').html(title);
    }

    if (body) {
        $modal.find('.modal-body').html(body);
    }

    if (footer) {
        $modal.find('.modal-footer').html(footer);
    }

    $(id).modal('show');

    $('.select2').select2({
        dropdownParent: $('#modal')
    });

    loadMasks();
};

export function loadMasks() {
    $('.date-mask').mask('11/11/1111');
    $('.cep-mask').mask('00000-000');
    var maskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
        options = {
            onKeyPress: function (val, e, field, options) {
                field.mask(maskBehavior.apply({}, arguments), options);
            }
        };

    $('.phone-mask').mask(maskBehavior, options);
    $('.cpf-mask').mask('000.000.000-00', { reverse: true });
    $('.cnpj-mask')
        .mask('AA.AAA.AAA/AAAA-00')
        .off('input.cnpj-uppercase')
        .on('input.cnpj-uppercase', function () {
            this.value = this.value.toUpperCase();
        });
    $('.money-mask').mask('000.000.000.000.000,00', { reverse: true });
}
